export default function About() {
  const zones = [
    'Valence',
    'Bourg-lès-Valence',
    'Guilherand-Granges',
    'Portes-lès-Valence',
    'Communes alentour',
  ];

  const advantages = [
    {
      icon: 'ri-user-star-line',
      title: 'Artisan Qualifié',
      description: 'Auto-entrepreneur expérimenté avec une expertise reconnue',
    },
    {
      icon: 'ri-time-line',
      title: 'Réactivité',
      description: 'Intervention rapide pour tous vos besoins urgents',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Travail Soigné',
      description: 'Un soin particulier porté aux finitions et à la qualité',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Proximité',
      description: 'Service local avec un suivi personnalisé',
    },
  ];

  return (
    <section id="a-propos" className="py-12 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">À Propos</h2>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
              <strong>Plombier Chauffagiste et Sanitaire à Valence</strong>, je mets mon expertise d'auto-entrepreneur au service de votre confort thermique et de vos installations d'eau.
            </p>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
              Spécialisé dans l'installation de climatisation et de systèmes de chauffage, j'interviens avec réactivité pour la pose, l'entretien et le dépannage de vos équipements.
            </p>
            <p className="text-sm sm:text-base text-gray-700 mb-6 sm:mb-8 leading-relaxed">
              Besoin d'une rénovation de salle de bains ? J'assure toute la partie sanitaire (pose de WC, douche, robinetterie) avec un soin particulier porté aux finitions.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
              {advantages.map((advantage, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className={`${advantage.icon} text-lg sm:text-xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1">{advantage.title}</h4>
                    <p className="text-xs sm:text-sm text-gray-600">{advantage.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white p-4 sm:p-6 rounded-xl shadow-sm">
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-3 sm:mb-4">Zones d'intervention</h3>
              <div className="flex flex-wrap gap-2">
                {zones.map((zone, index) => (
                  <span
                    key={index}
                    className="bg-teal-50 text-teal-700 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap"
                  >
                    <i className="ri-map-pin-line mr-1"></i>
                    {zone}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="relative h-64 sm:h-80 md:h-96 w-full rounded-xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/8cfd58db163eb898c3a7a5af6bc99894.jpg"
                alt="Plombier professionnel au travail"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 sm:absolute sm:-bottom-6 sm:-right-6 bg-white p-4 sm:p-6 rounded-xl shadow-xl sm:mt-0">
              <div className="flex items-center gap-3">
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-yellow-400 text-lg sm:text-xl"></i>
                  ))}
                </div>
                <div>
                  <div className="text-xl sm:text-2xl font-bold text-gray-900">5,0</div>
                  <div className="text-xs sm:text-sm text-gray-600">Avis Google</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
